import { RecentlyViewedTable } from "@/features/RecentlyViewed/components/RecentlyViewedTable";
import { PromptbookTemplateList } from "@/features/Templates/components/PromptbookTemplateList";
import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { SectionHeader } from "@pufflig/prompt-studio-ui";
import { Helmet } from "react-helmet";

export const WelcomePage = () => {
  return (
    <Box>
      <Helmet>
        <title>Home - Prompt Studio</title>
      </Helmet>
      <Flex direction="column" paddingLeft="4" paddingY="5" paddingTop="3" flex="1" gap="3">
        <Stack>
          <SectionHeader title="Create a new Promptbook" textStyle="heading/1" />
          <Text color="foreground.secondary">
            Promptbooks are your AI-powered notebooks for interactive data analysis.
          </Text>
        </Stack>
        <PromptbookTemplateList />
      </Flex>
      <Flex direction="column" paddingX="4" paddingY="5" paddingTop="3" flex="1" gap="3">
        <Stack>
          <SectionHeader title="Recently viewed" />
          <RecentlyViewedTable />
        </Stack>
      </Flex>
    </Box>
  );
};
